import React, { useState, useRef, useEffect } from 'react';
import './NavBar3.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/logos/logo.png';

const NavBar3 = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMobileMenu = () => setMobileMenuOpen(prev => !prev);

  const closeMenuOnOutsideClick = (e) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      hamburgerRef.current &&
      !hamburgerRef.current.contains(e.target)
    ) {
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeMenuOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeMenuOnOutsideClick);
  }, []);

  return (
    <nav className="NavBar3">
      <a href="/" target="_blank" rel="noopener noreferrer" className="NavBar3-logo">
        <img src={logo} alt="Logo" />
        <span>Skript</span>
      </a>
    </nav>
  );
};

export default NavBar3;
